import Card from 'components/common/Card/Card';

/**
 * Examples of Card.
 */

function CardExamplePage(): JSX.Element {
  return (
    <section id="card" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Card</h1>
      <div className="ExamplesPage__Description">
        It wraps content in a small box that visually separates it from surrounding content.
      </div>
      <div className="ExamplesPage__ExampleRow">
        <Card header="This is the header">
          <div>This is the body</div>
          <div>Line 1</div>
          <div>Line 2</div>
          <div>You can pass any React component as children to a card</div>
        </Card>
      </div>
    </section>
  );
}

export default CardExamplePage;
